import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { IApprovalTravelRequest, ITravelRequest, TravelRequestInput } from './interface';

const API_URI = `${environment.apiBaseUrl}/request-form`;
@Injectable({
    providedIn: 'root'
})
export class TravelRequetService {
    http: HttpClient = inject(HttpClient);

    getRequests(queryParams: { formTitle: string }) {
        return this.http.get<ITravelRequest[]>(API_URI, { params: queryParams });
    }

    createTravelForm(input: TravelRequestInput) {
        return this.http.post<ITravelRequest>(`${API_URI}/create/travel-form`, input);
    }

    getSingle(id: string) {
        return this.http.get<ITravelRequest>(`${API_URI}/single/${id}`);
    }

    getByUser(input: { id: string; query: string }) {
        return this.http.get<ITravelRequest[]>(
            `${API_URI}/user/${input.id}?formTitle=${input.query}`
        );
    }

    getApproverRequests(input: { id: string; query: string }) {
        return this.http.get<IApprovalTravelRequest[]>(
            `${API_URI}/assigned-requests/${input.id}?formTitle=${input.query}`
        );
    }
}
